'use strict';

var cov_167hrhiwd8 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.user.story.costs.factory.js',
        hash = 'e0d033d903cb271a16fd68faaaebb947c3c1889f',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.user.story.costs.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 27,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 56
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 25,
                    column: 11
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 27,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 26,
                        column: 5
                    }
                },
                line: 9
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        f: {
            '0': 0,
            '1': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_167hrhiwd8.s[0]++;
(function () {
    'use strict';

    cov_167hrhiwd8.f[0]++;
    cov_167hrhiwd8.s[1]++;
    angular.module('app').factory('UserStoryCostsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_167hrhiwd8.f[1]++;
        cov_167hrhiwd8.s[2]++;

        return restmod.model('/user-story-costs').mix('MixinContainable', {
            $config: {
                contains: {
                    component: {
                        type: 'belongsTo',
                        table: 'ComponentsTable',
                        foreignKey: 'component'
                    },
                    userStory: {
                        type: 'belongsTo',
                        table: 'UserStoriesTable',
                        foreignKey: 'user_story'
                    }
                }
            }
        });
    }
})();